var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-page" },
    [
      _vm.noItemsAtMount ? _c("empty-cart") : _vm._e(),
      _vm._v(" "),
      _vm.showMinimalCheckout ? _c("checkout-minimal") : _vm._e(),
      _vm._v(" "),
      !_vm.showMinimalCheckout ? _c("offer-coupons") : _vm._e(),
      _vm._v(" "),
      !_vm.showMinimalCheckout ? _c("offers") : _vm._e(),
      _vm._v(" "),
      !_vm.showMinimalCheckout
        ? _c("div", { staticClass: "columns center--mobile" }, [
            _c(
              "div",
              { class: _vm.styleMainSection() },
              [
                _c(
                  "checkout-section",
                  {
                    attrs: {
                      identity: "section-contact",
                      label: "Contact Details"
                    }
                  },
                  [_c("contact-details")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "checkout-section",
                  {
                    key: _vm.serviceSectionKey,
                    attrs: { identity: "method-section", label: "Service Type" }
                  },
                  [
                    _c("ServiceTypeChooser", {
                      attrs: { isStreamLined: true }
                    }),
                    _vm._v(" "),
                    _vm.hasErrors("serviceType")
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.errors.serviceType))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isServiceTypeDelivery
                      ? _c("div", { attrs: { id: "leave-at-door" } }, [
                          _c("div", { staticClass: "field-body" }, [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "control" }, [
                                _c(
                                  "div",
                                  { staticClass: "flex-column control-group" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex-full-width" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            ref: "leaveAtDoorCheckbox",
                                            staticClass:
                                              "control control--checkbox cust-radio"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.leaveAtDoor,
                                                  expression: "leaveAtDoor"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                role: "checkbox",
                                                "aria-checked": "true",
                                                "aria-label": "leave at door"
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.leaveAtDoor
                                                )
                                                  ? _vm._i(
                                                      _vm.leaveAtDoor,
                                                      null
                                                    ) > -1
                                                  : _vm.leaveAtDoor
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.leaveAtDoor,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.leaveAtDoor = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.leaveAtDoor = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.leaveAtDoor = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "control__indicator checkbox"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "Leave items at my doorstep"
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasSelectedService
                  ? _c(
                      "checkout-section",
                      {
                        attrs: {
                          identity: "address-chooser-section",
                          label: _vm.serviceTypeLabel
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _vm.showOrderDestinationSection
                              ? _c("order-destination")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showMap
                              ? [
                                  _c("BaseMap", {
                                    attrs: {
                                      zoom: 12,
                                      directions:
                                        _vm.serviceType ===
                                        _vm.EServiceType.SERVICE_TYPE_DELIVERY
                                          ? {
                                              origin: _vm.location,
                                              destination: _vm.focusedLocation
                                            }
                                          : null,
                                      storeLocation: _vm.location
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setLocation(
                                          _vm.deliveryAddress
                                        )
                                      }
                                    }
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.serviceType ===
                          _vm.EServiceType.SERVICE_TYPE_DELIVERY &&
                        _vm.getCustomerId
                          ? _c("address-chooser", {
                              on: {
                                error: function(value) {
                                  return (_vm.errors["address"] = value)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasErrors("address") && _vm.getCustomerId
                          ? _c("p", { staticClass: "error" }, [
                              _vm._v(_vm._s(_vm.errors.address))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "checkout-section",
                  {
                    attrs: { identity: "time-chooser-section", label: "Time" }
                  },
                  [
                    _c("BaseDatePicker"),
                    _vm._v(" "),
                    _vm.hasErrors("orderTime")
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.errors.orderTime))
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "checkout-section",
                  {
                    attrs: {
                      identity: "payment-chooser-section",
                      label: "Payment"
                    }
                  },
                  [
                    _c("payment-method-control"),
                    _vm._v(" "),
                    _vm.preorder === _vm.EPreorder.PAY_NOW
                      ? [_c("payment-chooser")]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasErrors("payment")
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.errors.payment))
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "checkout-section",
                  {
                    attrs: { identity: "section-coupon", label: "Coupon Code" }
                  },
                  [_c("coupon-field")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "checkout-section",
                  {
                    attrs: { identity: "section-instructions", label: "Notes" }
                  },
                  [_c("checkout-special-instructions")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "checkout-section",
                  {
                    attrs: {
                      identity: "section-checkout-summary",
                      label: "Order"
                    }
                  },
                  [
                    _c("checkout-summary", {
                      on: {
                        change: function($event) {
                          return _vm.proposeOrder()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "has-text-centered",
                        class: _vm.styleMobileCheckoutFooter,
                        attrs: { id: "c2a" },
                        on: {
                          click: function($event) {
                            return _vm.checkValidForm()
                          }
                        }
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "error", attrs: { id: "errs" } },
                          _vm._l(_vm.errors, function(err, key) {
                            return _c("li", { key: key }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(err) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.$mq === "mobile"
                          ? _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "has-text-centered c2a-order-icons"
                                },
                                [
                                  _vm._v(
                                    "👍 " +
                                      _vm._s(
                                        _vm.$appConstants.checkout.icons
                                          .foodType
                                      ) +
                                      " 👏"
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("BaseButton", {
                          attrs: {
                            title: "Place Order",
                            classNames: ["button--modifier", "addToCart"],
                            disabled: _vm.isCheckoutDisabled
                          },
                          on: { click: _vm.sendOrder }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mobile-sidebar" },
                          [
                            _vm.$mq === "mobile"
                              ? _c("checkout-sidebar", {
                                  on: { placeOrder: _vm.sendOrder }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.$mq === "desktop"
              ? _c(
                  "div",
                  {
                    staticClass: "column is-4-desktop is-5-tablet is-12-mobile"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "is-pulled-right-tablet has-text-centered-mobile sidebar",
                        class: {
                          "bottom-tracker-position":
                            _vm.$mq === "desktop" && _vm.activeOrder
                        }
                      },
                      [
                        _vm.$mq !== "mobile"
                          ? _c("checkout-sidebar", {
                              on: { placeOrder: _vm.sendOrder }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44a974af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44a974af","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/Checkout.vue
// module id = null
// module chunks = 